<template>
  <b-modal
    :ref="`modal-verify-doc-number-open-text-panel`"
    title="Comprobar numeración en Librería"
    ok-title="Comprobar numeración"
    hide-footer
  >
    <div class="row">
      <div class="col-12">
        <b-overlay
          variant="white"
          :show="loading"
          spinner-variant="primary"
          blur="0"
          opacity=".75"
          rounded="sm"
        >
          <h4>Listado de versiones encontradas</h4>
          <div class="alert alert-warning p-3">
            <strong>IMPORTANTE</strong>
            La versión numerada se recupera posterior al envío del documento,
            si solo ves una versión es que aún no se numera
          </div>
          <div
            class="row"
          >
            <ul class="wrap-versions mt-5 col-12">
              <li
                class="version"
                :key="'version-'+$index"
                v-for="(version,$index) in versions"
              >
                <div class="actions">
                  <feather-icon
                    size="18"
                    icon="EyeIcon"
                    color="green"
                    v-tooltip="'Ver documento de la versión'"
                    v-on:click="viewVersionDocument(version)"
                  />
                </div>
                <strong>Doc Nº:</strong> {{ version['DOCNUMBER'] }}
                <br/>
                <strong>Versión:</strong>{{ version['VERSION_ID'] }}
                <span class="float-right">
              {{ version['LASTEDITDATE'] | timeAgo(true)}}
            </span>
              </li>
            </ul>
          </div>
          <div class="row mt-5">
            <div class="col-12 text-right">
              <button
                v-if="versions.length > 1"
                class="btn btn-primary"
                v-on:click="startApproval()"
              >
                Iniciar proceso de aprobación
              </button>
              <button
                v-else
                class="btn btn-warning"
                v-on:click="startApproval()"
              >
                Iniciar proceso de aprobación solo con doc sin numerar
              </button>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </b-modal>
</template>
<script>

import { mapGetters } from 'vuex';

import { extraActionsApproval } from '@/febos/servicios/api/aprobaciones.api';
import { linkOpenText } from '@/febos/servicios/api/herramientas.api';

export default {
  components: {},
  data() {
    return {
      loading: false,
      versions: []
    };
  },
  computed: {
    ...mapGetters('Approvals', [
      'FileOnFlow'
    ])
  },
  methods: {
    async startApproval() {
      try {
        this.loading = true;
        await extraActionsApproval(
          this.file.idAprobacion,
          {
            accion: 'iniciar_ejecucion'
          }
        );
        this.$refs['modal-verify-doc-number-open-text-panel'].hide();
        this.$router.go();
      } finally {
        this.loading = false;
      }
    },
    async viewVersionDocument(version) {
      const {
        DOCNUMBER: numberDocument,
        VERSION_ID: idVersion,
        FILE_EXTENSION: extensionArchive
      } = version;
      try {
        this.loading = true;
        const extensionFile = extensionArchive.includes('\'')
          ? `.${extensionArchive.split('\'')[0]}`
          : `.${extensionArchive}`;
        const payloadIdVersion = {
          metodo: 'librerias_form_docs_version',
          library: 'library',
          idDoc: numberDocument,
          idVersion,
          extension: extensionFile,
          nombre: numberDocument
        };
        const response = await linkOpenText(payloadIdVersion);
        const responseUrl = response.data.document;
        window.open(responseUrl, '_blank');
      } finally {
        this.loading = false;
      }
    },
    async verifyDocNumberInOpenText() {
      this.$refs['modal-verify-doc-number-open-text-panel'].show();
      this.loading = true;
      try {
        const { data: { versiones } } = await extraActionsApproval(
          this.file.idAprobacion,
          {
            accion: 'recuperar_numerado_open_text'
          }
        );
        this.versions = versiones || [];
      } finally {
        this.loading = false;
      }
    }
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    flowId: {
      type: String
    }
  }
};
</script>
<style>
.actions * {
  cursor: pointer;
  position: relative;
  float: right;
  top: 1px;
}
.wrap-versions {
  max-height: 200px;
  overflow: scroll;
}
.version {
  padding: 4px;
  border-bottom: 1px solid darkgray;
}
</style>
